import { styled } from 'styled-components';
import { WebLink, WebLinkProps } from '../../../../../app-kit/components/WebLink/WebLink';
import {
  H3,
  H4,
  mediaHelper,
  paletteHelper,
  radiusHelper,
  spacingHelper,
} from '@property.com.au/ui-kit';
import originBanner from '../../../../../assets/origin-logo.svg';
import { ObservedElement } from '../../../../../app-kit/components/ObservedElement/ObservedElement';
import { DataGetter, trackEvent } from '@rea-argonaut/analytics';

const trackOriginCtaImpression = ({
  connectionType,
  upgradeAvailable,
}: {
  connectionType: string;
  upgradeAvailable: boolean;
}) => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_display_ads/jsonschema/1-0-0',
    data: {
      event_name: 'pca_display_ads',
      user_action: 'impression',
      type: 'banner',
      name: 'origin_banner',
      context: [
        {
          key: 'connection_type',
          value: connectionType,
        },
        {
          key: 'upgrade_available',
          value: String(upgradeAvailable),
        },
      ],
    },
  });

  trackEvent(event);
};

export interface OriginCTABanner {
  title: string;
  subtitle: string;
  ctaButton: WebLinkProps;
  connectionType: string;
  upgradeAvailable: boolean;
}
const OriginCTABannerWrapper = styled.div`
  background-color: ${paletteHelper('backgroundWarning')};
  width: 100%;
  padding: ${spacingHelper('large')};
  margin: ${spacingHelper('medium 0 small 0')};
  border-radius: ${radiusHelper('medium')};

  ${mediaHelper('mobile')} {
    padding: ${spacingHelper('medium')};
  }
`;
const Title = styled(H3)`
  color: #6b3e24;
  margin-bottom: ${spacingHelper('twoExtraSmall')};
`;
const Subtitle = styled(H4)`
  color: #e5451b;
  max-width: 36rem;
`;
const CTAButton = styled(WebLink)`
  background-color: #ec0000;
  height: fit-content;
  ${mediaHelper('mobile')} {
    margin-top: ${spacingHelper('medium')};
    width: 100%;
  }
  &:hover {
    background-color: #c00;
  }
  &:focus {
    background-color: #ad0000;
  }
`;
const StyleImage = styled.img`
  width: auto;
  min-width: 137px;
  height: 42px;
  min-height: 42px;
  align-self: center;
  ${mediaHelper('mobile')} {
    align-self: flex-start;
  }
`;
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  column-gap: ${spacingHelper('medium')};
  margin-top: ${spacingHelper('medium')};

  ${mediaHelper('mobile')} {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column-reverse;
  }
`;

export const OriginCTABanner: React.FC<OriginCTABanner> = ({
  title,
  subtitle,
  ctaButton,
  connectionType,
  upgradeAvailable,
}) => {
  return (
    <ObservedElement
      onFirstIntersect={() => trackOriginCtaImpression({ connectionType, upgradeAvailable })}
    >
      <OriginCTABannerWrapper>
        <Title variant="body01Bold">{title}</Title>
        <Subtitle variant="subtitle02">{subtitle}</Subtitle>
        <FlexContainer>
          <CTAButton {...ctaButton} />
          <StyleImage src={originBanner} alt="origin-logo" />
        </FlexContainer>
      </OriginCTABannerWrapper>
    </ObservedElement>
  );
};
